import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "type" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "type" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "language" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "subtype" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "subject" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "buttons" }
const _hoisted_12 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_13 = ["data-dp-tooltip"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "edit", -1)
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.notificationType), 1)
    ]),
    _createElementVNode("td", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.communicationType), 1)
    ]),
    _createElementVNode("td", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.template.language_code), 1)
    ]),
    _createElementVNode("td", _hoisted_7, [
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.template.discriminator), 1)
    ]),
    _createElementVNode("td", _hoisted_9, [
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.template.subject), 1)
    ]),
    _createElementVNode("td", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update',_ctx.template))),
          class: "btn btn-icon btn-primary ms-2",
          "data-dp-tooltip": _ctx.$t('edit'),
          "data-dp-position": "left"
        }, _hoisted_15, 8, _hoisted_13),
        _createVNode(_component_BaseDeleteButton, {
          deleteData: () => _ctx.$emit('delete', _ctx.template),
          pageUI: _ctx.parentPageUI,
          itemKey: _ctx.template.id,
          class: "ms-2",
          "data-dp-tooltip": _ctx.$t('delete'),
          "data-dp-position": "left"
        }, null, 8, ["deleteData", "pageUI", "itemKey", "data-dp-tooltip"])
      ])
    ])
  ]))
}